import React from "react"
import { createUseStyles, useTheme } from "react-jss"

const useStyles = createUseStyles({
  legendContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  colorBox: {
    width: "16px", // Equivalent to `w-4`
    height: "16px", // Equivalent to `h-4`
    borderRadius: "4px", // Equivalent to `rounded-md`
    marginRight: "8px",
    backgroundColor: ({ color }: { color: string }) => color,
  },
  legend: {
    color: "#000",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0.44px",
  },
})

const Legend = (props: { color: string; name: string }) => {
  const theme: any = useTheme()
  const classes = useStyles({ theme, color: props.color })

  return (
    <div className={classes.legendContainer}>
      <div className={classes.colorBox}></div>
      <div className={classes.legend}>{props.name}</div>
    </div>
  )
}

export default Legend
